"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyMap = void 0;
exports.KeyMap = {
    Up: "ArrowUp",
    Down: "ArrowDown",
    Left: "ArrowLeft",
    Right: "ArrowRight",
    Space: " ",
    Enter: "Enter",
    Esc: "Escape",
    Backspace: "Backspace",
    Tab: "Tab",
};
//# sourceMappingURL=key-map.js.map